// Register before any chart is created; lazy registration cannot initialize existing charts.
import 'chartjs-plugin-zoom';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, Router, RouterModule } from '@angular/router';

import { MarkdownModule } from 'ngx-markdown';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { TranslocoCoreModule } from './core/transloco/transloco.module';
import { RegisterIconsModule } from './shared/register-icons/register-icons.module';

import { FuseModule } from '@fuse';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseAlertModule } from '@fuse/components/alert';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

import { AppComponent } from 'app/app.component';
import { IconSnackBarComponent } from '@sociuu/utility/icon-snack-bar';
import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { CookieConsentFormDialogComponent } from './cookie-consent-form/cookie-consent-form-dialog.component';

import { appRoutes } from 'app/app.routing';
import { mockApiServices } from 'app/mock-api';
import { CookieService } from 'ngx-cookie-service';
import { appConfig } from 'app/core/config/app.config';

import * as Sentry from "@sentry/angular-ivy";


const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  declarations: [AppComponent, IconSnackBarComponent, AlertBannerComponent, CookieConsentFormDialogComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseAlertModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    // Core module of your application
    // CoreModule,
    CoreModule.forRoot(),

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),

    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,

    RegisterIconsModule,
    TranslocoCoreModule.forRoot(),
  ],

  providers: [
    CookieService,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 3000, panelClass: 'snackbar' },
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        // Disable Sentry feedback dialog (keeps logging silent)
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
  entryComponents: [IconSnackBarComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
